import { Directive, inject } from '@angular/core';
import { ApAlertService, ApComplexModal, ApNotificationService } from 'webcommon/core-ui';
import { IColumnPk } from 'webcommon/shared';
import { FcItemModalContext, FcItemModalMode } from '../../models/FcItemModalContext';

@Directive()
export abstract class FcItemModalBaseComponent extends ApComplexModal<IColumnPk> {

  public readonly apNotificationService = inject(ApNotificationService);
  public readonly alertService = inject(ApAlertService);
  public fcModalItemContext: FcItemModalContext;

  isLoading = false;
  isSaving = false;

  onClose(result: IColumnPk) {
    const action = (this.fcModalItemContext.mode === FcItemModalMode.Modify) ? 'updated' : 'created';
    const successMessage = this.fcModalItemContext.findControlName + ' has been ' +
    action + '.';
    this.apNotificationService.success(successMessage);
    this.apClose(result);
  }

  onCancel() {
    super.apUserCancel();
  }
}
